<template>
    <div class="card p-2 pb-3 review-box tp-reviews">
        <div class="tp-widget-review m-0" style="height:inherit;">
            <div class="top-row">
                <div class="tp-widget-stars mt-3">
                    <div class="">
                        <div class="tp-stars tp-stars--5">
                            <div
                                style="position: relative; height: 0; width: 100%; padding: 0; padding-bottom: 18.326693227091635%;">

                                <!-- https://codepen.io/edcastano/pen/rLoqxo -->

                                <svg role="img" aria-labelledby="starRating" viewBox="0 0 251 46"
                                     xmlns="http://www.w3.org/2000/svg"
                                     style="position: absolute; height: 100%; width: 100%; left: 0; top: 0;">
                                    <title id="starRating" lang="en">5 out of five star rating on Trustpilot</title>
                                    <g class="tp-star">
                                        <path class="tp-star__canvas" fill="#dcdce6"
                                              d="M0 46.330002h46.375586V0H0z"></path>
                                        <path class="tp-star__shape"
                                              d="M39.533936 19.711433L13.230239 38.80065l3.838216-11.797827L7.02115 19.711433h12.418975l3.837417-11.798624 3.837418 11.798624h12.418975zM23.2785 31.510075l7.183595-1.509576 2.862114 8.800152L23.2785 31.510075z"
                                              fill="#FFF"></path>
                                    </g>
                                    <g class="tp-star">
                                        <path class="tp-star__canvas" fill="#dcdce6"
                                              d="M51.24816 46.330002h46.375587V0H51.248161z"></path>
                                        <path class="tp-star__canvas--half" fill="#dcdce6"
                                              d="M51.24816 46.330002h23.187793V0H51.248161z"></path>
                                        <path class="tp-star__shape"
                                              d="M74.990978 31.32991L81.150908 30 84 39l-9.660206-7.202786L64.30279 39l3.895636-11.840666L58 19.841466h12.605577L74.499595 8l3.895637 11.841466H91L74.990978 31.329909z"
                                              fill="#FFF"></path>
                                    </g>
                                    <g class="tp-star">
                                        <path class="tp-star__canvas" fill="#dcdce6"
                                              d="M102.532209 46.330002h46.375586V0h-46.375586z"></path>
                                        <path class="tp-star__canvas--half" fill="#dcdce6"
                                              d="M102.532209 46.330002h23.187793V0h-23.187793z"></path>
                                        <path class="tp-star__shape"
                                              d="M142.066994 19.711433L115.763298 38.80065l3.838215-11.797827-10.047304-7.291391h12.418975l3.837418-11.798624 3.837417 11.798624h12.418975zM125.81156 31.510075l7.183595-1.509576 2.862113 8.800152-10.045708-7.290576z"
                                              fill="#FFF"></path>
                                    </g>
                                    <g class="tp-star">
                                        <path class="tp-star__canvas" fill="#dcdce6"
                                              d="M153.815458 46.330002h46.375586V0h-46.375586z"></path>
                                        <path class="tp-star__canvas--half" fill="#dcdce6"
                                              d="M153.815458 46.330002h23.187793V0h-23.187793z"></path>
                                        <path class="tp-star__shape"
                                              d="M193.348355 19.711433L167.045457 38.80065l3.837417-11.797827-10.047303-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418974zM177.09292 31.510075l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
                                              fill="#FFF"></path>
                                    </g>
                                    <g class="tp-star">
                                        <path class="tp-star__canvas" fill="#dcdce6"
                                              d="M205.064416 46.330002h46.375587V0h-46.375587z"></path>
                                        <path class="tp-star__canvas--half" fill="#dcdce6"
                                              d="M205.064416 46.330002h23.187793V0h-23.187793z"></path>
                                        <path class="tp-star__shape"
                                              d="M244.597022 19.711433l-26.3029 19.089218 3.837419-11.797827-10.047304-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418975zm-16.255436 11.798642l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
                                              fill="#FFF"></path>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a :href="link"
               target="_blank" rel="nofollow">
                <div class="header">
                    {{ title }}
                </div>
            </a>
            <div>
                <div class="text text-single-line">
                    <em>
                        {{ text }}
                    </em>
                </div>
            </div>
            <a :href="link"
               target="_blank" rel="nofollow">
                <div class="date-and-user-info-wrapper">
                    <div class="name secondary-text fs-9">
                        {{ name }}
                    </div>
<!--                    <div class="date secondary-text fs-9">{{ daysPassed }} dagen geleden</div>-->
                </div>
            </a>
        </div>
    </div>
</template>

<script>

import { DateTime } from "luxon";

export default {
    components: {},

    props: ['name', 'link', 'text', 'date', 'title'],

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        dateObject() {
            return DateTime.fromISO(this.date).setLocale('nl');
        },
        daysPassed() {
            let date = this.dateObject;
            let diff = DateTime.now().diff(date, ['days']);
            return Math.round(diff.toObject().days, 0);
        }
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
<style lang="scss">
.card {
    border: 0;
    box-shadow: 0 2px 15px -3px rgb(0 0 0 / 7%), 0 10px 20px -2px rgb(0 0 0 / 4%);
}
.tp-reviews {
    html,
    body,
    div,
    span,
    applet,
    object,
    iframe,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    blockquote,
    pre,
    a,
    abbr,
    acronym,
    address,
    big,
    cite,
    code,
    del,
    dfn,
    //em,
    img,
    ins,
    kbd,
    q,
    s,
    samp,
    small,
    strike,
    strong,
    sub,
    sup,
    tt,
    var,
    b,
    u,
    i,
    center,
    dl,
    dt,
    dd,
    ol,
    ul,
    li,
    fieldset,
    form,
    label,
    legend,
    table,
    caption,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td,
    article,
    aside,
    canvas,
    details,
    embed,
    figure,
    figcaption,
    footer,
    header,
    hgroup,
    menu,
    nav,
    output,
    ruby,
    section,
    summary,
    time,
    mark,
    audio,
    video {
        border: 0;
        font: inherit;
        font-size: 100%;
        margin: 0;
        padding: 0;
        vertical-align: baseline
    }

    article,
    aside,
    details,
    figcaption,
    figure,
    footer,
    header,
    hgroup,
    menu,
    nav,
    section {
        display: block
    }

    body {
        line-height: 1
    }

    ol,
    ul {
        list-style: none
    }

    blockquote,
    q {
        quotes: none
    }

    blockquote::before,
    blockquote::after,
    q::before,
    q::after {
        content: "";
        content: none
    }

    table {
        border-collapse: collapse;
        border-spacing: 0
    }

    body {
        font-family: "Helvetica Neue", "Helvetica", "Arial", "sans-serif";
        font-size: 12px
    }

    b,
    strong {
        font-weight: 700
    }

    .tp-widget-businessinfo,
    .tp-widget-wrapper .wrapper-right .tp-widget-reviews-filter-label {
        font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-weight: 300
    }

    .tp-widget-review__source__information .information-text {
        font-family: "Helvetica Neue", "Helvetica", "Arial", "sans-serif";
        font-weight: 400
    }

    .tp-widget-humanscore,
    .tp-widget-empty-horizontal__title,
    .tp-widget-empty-vertical__title,
    .bold-underline {
        font-family: "Helvetica Neue", "Helvetica", "Arial", "sans-serif";
        font-weight: 500
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        .tp-widget-humanscore,
        .tp-widget-empty-horizontal__title,
        .tp-widget-empty-vertical__title,
        .bold-underline {
            font-weight: 600
        }
    }

    .tp-widget-review__source__information .information-title {
        font-family: "Helvetica Neue", "Helvetica", "Arial", "sans-serif";
        font-weight: 700
    }

    *,
    ::after,
    ::before {
        box-sizing: border-box
    }

    .hidden {
        display: none
    }

    .tp-widget-loader,
    .tp-widget-fallback {
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%)
    }

    .tp-widget-review__source__information {
        background-color: #fff;
        border: 1px solid #dcdce6;
        border-radius: 2px;
        box-shadow: 0px 4px 24px rgba(0, 0, 0, .15);
        color: #1b1b21;
        display: none;
        left: -50px;
        line-height: 16px;
        padding: 16px 8px;
        position: absolute;
        top: calc(100% + 12px);
        z-index: 10;
        cursor: default
    }

    @media screen and (min-width: 530px) {
        .tp-widget-review__source__information {
            padding: 16px
        }
    }

    #fallback-logo {
        display: none
    }

    .no-svg #fallback-logo {
        display: inline-block
    }

    .tp-widget-wrapper {
        height: 100%;
        margin: 0 auto;
        max-width: 750px;
        position: relative
    }

    @media screen and (min-width: 750px) {
        .tp-widget-wrapper--fullwidth {
            max-width: 100%
        }
        .tp-widget-wrapper--fullwidth .tp-widget-attributes-scores-wrapper {
            border-bottom: 1px solid #d6d6d6;
            display: -ms-grid;
            display: grid;
            -ms-grid-columns: 1fr 1fr;
            grid-template-columns:1fr 1fr;
            grid-gap: 16px
        }
        .tp-widget-wrapper--fullwidth .tp-widget-attributes-scores-wrapper .tp-widget-scores,
        .tp-widget-wrapper--fullwidth .tp-widget-attributes-scores-wrapper .tp-widget-attributes {
            border-bottom: none
        }
        .tp-widget-wrapper--fullwidth .tp-widget-attributes-scores-wrapper .tp-widget-scores {
            -ms-grid-row: 1;
            grid-row: 1
        }
    }

    .tp-stars .tp-star__canvas,
    .tp-stars .tp-star__canvas--half {
        fill: #dcdce6
    }

    .tp-stars .tp-star__shape {
        fill: #fff
    }

    .tp-stars--1 .tp-star:nth-of-type(-n + 1) .tp-star__canvas,
    .tp-stars--1 .tp-star:nth-of-type(-n + 1) .tp-star__canvas--half {
        fill: #ff3722
    }

    .tp-stars--2 .tp-star:nth-of-type(-n + 2) .tp-star__canvas,
    .tp-stars--2 .tp-star:nth-of-type(-n + 2) .tp-star__canvas--half {
        fill: #ff8622
    }

    .tp-stars--3 .tp-star:nth-of-type(-n + 3) .tp-star__canvas,
    .tp-stars--3 .tp-star:nth-of-type(-n + 3) .tp-star__canvas--half {
        fill: #ffce00
    }

    .tp-stars--4 .tp-star:nth-of-type(-n + 4) .tp-star__canvas,
    .tp-stars--4 .tp-star:nth-of-type(-n + 4) .tp-star__canvas--half {
        fill: #73cf11
    }

    .tp-stars--5 .tp-star:nth-of-type(-n + 5) .tp-star__canvas,
    .tp-stars--5 .tp-star:nth-of-type(-n + 5) .tp-star__canvas--half {
        fill: #00b67a
    }

    .tp-stars--1--half .tp-star:nth-of-type(-n + 2) .tp-star__canvas--half {
        fill: #ff3722
    }

    .tp-stars--2--half .tp-star:nth-of-type(-n + 3) .tp-star__canvas--half {
        fill: #ff8622
    }

    .tp-stars--3--half .tp-star:nth-of-type(-n + 4) .tp-star__canvas--half {
        fill: #ffce00
    }

    .tp-stars--4--half .tp-star:nth-of-type(-n + 4) .tp-star__canvas,
    .tp-stars--4--half .tp-star:nth-of-type(-n + 4) .tp-star__canvas--half {
        fill: #00b67a
    }

    .tp-stars--4--half .tp-star:nth-of-type(-n + 5) .tp-star__canvas--half {
        fill: #00b67a
    }

    .tp-widget-loader,
    .tp-widget-fallback {
        max-width: 50%;
        text-align: center;
        width: 400vh
    }

    .tp-widget-loader svg,
    .tp-widget-fallback svg {
        width: 100%
    }

    @media screen and (min-width: 400px) {
        .tp-widget-loader,
        .tp-widget-fallback {
            max-width: 200px
        }
    }

    .tp-widget-loader--loaded {
        opacity: 0
    }

    .bold-underline {
        border-bottom: 1px solid rgba(25, 25, 25, .6)
    }

    .bold-underline:hover {
        border-color: #191919
    }

    .dark {
        color: #fff
    }

    .dark a {
        color: #fff
    }

    .dark .bold-underline:not(.bold-underline--single-theme) {
        border-color: rgba(255, 255, 255, .6)
    }

    .dark .bold-underline:not(.bold-underline--single-theme):hover {
        border-color: #fff
    }

    .dark .tp-logo__text {
        fill: #fff
    }

    .dark .tp-widget-loader .tp-logo__text {
        fill: #191919
    }

    .sr-only:not(:focus):not(:active) {
        clip: rect(0 0 0 0);
        -webkit-clip-path: inset(50%);
        clip-path: inset(50%);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px
    }

    html {
        height: 100%;
        overflow: hidden
    }

    img {
        border: 0
    }

    svg {
        display: block;
        width: 100%
    }

    a {
        color: #191919;
        text-decoration: none
    }

    .tp-widget-empty-vertical {
        -ms-flex-align: center;
        align-items: center;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: column;
        flex-direction: column;
        -ms-flex-pack: center;
        justify-content: center
    }

    .tp-widget-empty-vertical__title {
        font-size: 18px;
        margin: 0 0 12px;
        text-align: center
    }

    .tp-widget-empty-vertical__stars {
        margin: 0 0 8px;
        width: 150px
    }

    .tp-widget-empty-vertical__subtitle-wrapper {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: row;
        flex-direction: row
    }

    .tp-widget-empty-vertical__subtitle {
        -ms-flex-align: center;
        align-items: center;
        display: -ms-flexbox;
        display: flex;
        font-size: 14px;
        text-align: center
    }

    .tp-widget-empty-vertical__logo {
        margin: 0 0 5px 5px;
        width: 90px
    }

    .tp-widget-empty-horizontal {
        -ms-flex-align: center;
        align-items: center;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: row;
        flex-direction: row;
        height: 100%;
        -ms-flex-pack: center;
        justify-content: center
    }

    .tp-widget-empty-horizontal__title {
        font-size: 14px;
        text-align: center
    }

    .tp-widget-empty-horizontal__logo {
        margin: 0 0 5px 5px;
        width: 90px
    }

    @media screen and (max-width: 300px) {
        .tp-widget-empty-vertical__subtitle-wrapper {
            -ms-flex-align: center;
            align-items: center;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-direction: column;
            flex-direction: column
        }
        .tp-widget-empty-vertical__logo {
            margin: 5px 0 0
        }
        .tp-widget-empty-horizontal {
            -ms-flex-direction: column;
            flex-direction: column
        }
        .tp-widget-empty-horizontal__logo {
            margin: 0
        }
    }

    .tp-widget-review__source {
        position: relative;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -ms-flex-align: center;
        align-items: center;
        color: #6c6c85
    }

    .tp-widget-review__source__information {
        width: 180px
    }

    @media screen and (min-width: 530px) {
        .tp-widget-review__source__information {
            width: 250px
        }
    }

    .tp-widget-review__source__information a {
        color: #1a66ff;
        text-decoration: underline
    }

    .tp-widget-review__source__information .information-title {
        color: #1b1b21;
        font-size: 13px;
        line-height: 16px;
        margin-bottom: 4px
    }

    .tp-widget-review__source__information .information-text {
        color: #1b1b21;
        display: block;
        font-size: 13px;
        line-height: 16px
    }

    .tp-widget-review__source__arrow {
        background-color: #fff;
        border-left: 1px solid #dcdce6;
        border-top: 1px solid #dcdce6;
        content: "";
        display: block;
        position: absolute;
        left: 28%;
        top: -8px;
        height: 14px;
        width: 14px;
        transform: rotate(45deg)
    }

    @media screen and (min-width: 530px) {
        .tp-widget-review__source__arrow {
            left: 20%
        }
    }

    .tp-widget-review__source:hover .tp-widget-review__source__information {
        display: block
    }

    .tp-widget-review__source:hover::after {
        content: "";
        display: block;
        height: 20px;
        left: 0;
        position: absolute;
        top: 100%;
        width: 100%
    }

    .top-row {
        display: -ms-flexbox;
        display: flex;
        gap: 8px
    }

    .top-row .tp-widget-stars {
        margin: 0 0 12px;
        width: 99px
    }

    .tp-widget-review__source {
        display: block;
        min-width: 0
    }

    .verification-label-wrapper {
        position: relative
    }

    .verification-label-wrapper .verification-label {
        -ms-flex-align: center;
        align-items: center;
        display: -ms-flexbox;
        display: flex;
        font-size: 13px;
        font-weight: 400;
        height: 16px;
        line-height: 16px;
        margin-top: 2px;
        overflow: hidden
    }

    .verification-label-wrapper .verification-label .label-icon {
        -ms-flex-negative: 0;
        flex-shrink: 0;
        height: 14px;
        margin: 0 4px 2px auto;
        width: 14px
    }

    .verification-label-wrapper .verification-label .label-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis
    }

    .dark .tp-widget-review .name,
    .dark .tp-widget-review .date {
        color: rgba(255, 255, 255, .6)
    }

    .dark .tp-widget-wrapper .wrapper-right .tp-widget-reviews-filter-label {
        color: #fff
    }

    .dark .tp-widget-review-next .svg-slider-arrow .arrow-slider-circle,
    .dark .tp-widget-review-prev .svg-slider-arrow .arrow-slider-circle {
        stroke: rgba(255, 255, 255, .6)
    }

    .dark .tp-widget-review-next .svg-slider-arrow .arrow-slider-shape,
    .dark .tp-widget-review-prev .svg-slider-arrow .arrow-slider-shape {
        fill: rgba(255, 255, 255, .6)
    }

    .dark .tp-widget-review-next.display-none .svg-slider-arrow .arrow-slider-circle,
    .dark .tp-widget-review-prev.display-none .svg-slider-arrow .arrow-slider-circle {
        stroke: rgba(255, 255, 255, .3)
    }

    .dark .tp-widget-review-next.display-none .svg-slider-arrow .arrow-slider-shape,
    .dark .tp-widget-review-prev.display-none .svg-slider-arrow .arrow-slider-shape {
        fill: rgba(255, 255, 255, .3)
    }

    .dark .tp-widget-review__source {
        color: #fff
    }

    html {
        -webkit-font-smoothing: antialiased
    }

    .tp-widget-wrapper {
        max-width: none;
        min-height: 150px;
        min-width: 300px;
        will-change: transform
    }

    .tp-widget-wrapper .wrapper-left {
        text-align: center;
        z-index: 100
    }

    .tp-widget-wrapper .wrapper-right {
        margin: 20px 0 0;
        overflow: hidden;
        padding: 0 40px;
        position: relative
    }

    .tp-widget-wrapper .wrapper-right .tp-widget-reviews-filter-label {
        color: #191919;
        font-size: 13px;
        font-weight: 400;
        line-height: 16px;
        padding: 0 0 0 20px
    }

    .tp-widget-humanscore {
        font-size: 24px;
        margin: 0 0 12px
    }

    .tp-widget-stars {
        margin: 0 auto 12px;
        width: 162px
    }

    .tp-widget-businessinfo {
        font-size: 13px;
        line-height: 16px;
        margin: 0 0 16px
    }

    @media screen and (max-height: 139px) {
        .tp-widget-businessinfo {
            margin-bottom: 8px
        }
    }

    .tp-widget-logo {
        margin: 0 auto;
        width: 106px
    }

    .tp-widget-reviews-wrapper {
        overflow: hidden;
        position: relative
    }

    .tp-widget-reviews {
        height: 100%;
        overflow: hidden;
        position: relative;
        white-space: nowrap
    }

    .tp-widget-review {
        display: inline-block;
        height: 110px;
        margin: 0 15px 10px 0;
        padding: 0 0 0 20px;
        position: relative;
        vertical-align: top;
        white-space: normal
    }

    @media screen and (max-height: 139px) {
        .tp-widget-review {
            margin-bottom: 0
        }
    }

    .tp-widget-review .header {
        font-size: 14px;
        font-weight: 700;
        //height: 16px;
        margin: 0 0 6px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%
    }

    .tp-widget-review .text {
        font-size: 13px;
        line-height: 16px;
        margin: 0 0 8px;
        //max-height: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: break-word
    }

    .tp-widget-review .text-single-line {
        //white-space: nowrap
    }

    .tp-widget-review .date-and-user-info-wrapper {
        display: -ms-flexbox;
        display: flex;
        color: rgba(0, 0, 0, .6)
    }

    .tp-widget-review .date-and-user-info-wrapper .name {
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap
    }

    .tp-widget-review .date-and-user-info-wrapper .date {
        -ms-flex-negative: 0;
        flex-shrink: 0;
        margin-left: 3px
    }

    .tp-widget-review-prev {
        left: 0
    }

    .tp-widget-review-prev .svg-slider-arrow {
        transform: translate(-50%, -50%)
    }

    .tp-widget-review-next {
        right: 0
    }

    .tp-widget-review-next .svg-slider-arrow {
        transform: translate(-50%, -50%) rotate(180deg)
    }

    .tp-widget-review-next,
    .tp-widget-review-prev {
        cursor: pointer;
        height: 100%;
        position: absolute;
        top: 0;
        width: 40px;
        z-index: 10
    }

    .tp-widget-review-next .svg-slider-arrow,
    .tp-widget-review-prev .svg-slider-arrow {
        display: block;
        left: 50%;
        position: absolute;
        top: 50%;
        width: 24px
    }

    .tp-widget-review-next .svg-slider-arrow .arrow-slider-circle,
    .tp-widget-review-prev .svg-slider-arrow .arrow-slider-circle {
        stroke: #8c8c8c
    }

    .tp-widget-review-next .svg-slider-arrow .arrow-slider-shape,
    .tp-widget-review-prev .svg-slider-arrow .arrow-slider-shape {
        fill: #8c8c8c
    }

    .tp-widget-review-next.display-none,
    .tp-widget-review-prev.display-none {
        cursor: default
    }

    .tp-widget-review-next.display-none .svg-slider-arrow .arrow-slider-circle,
    .tp-widget-review-prev.display-none .svg-slider-arrow .arrow-slider-circle {
        stroke: #d1d1d1
    }

    .tp-widget-review-next.display-none .svg-slider-arrow .arrow-slider-shape,
    .tp-widget-review-prev.display-none .svg-slider-arrow .arrow-slider-shape {
        fill: #d1d1d1
    }

    @media screen and (min-width: 520px) {
        .tp-widget-wrapper .wrapper-left {
            float: left;
            width: 200px
        }
        .tp-widget-wrapper .wrapper-right {
            float: left;
            margin: 0;
            width: calc(100% - 200px)
        }
    }
    @media screen and (min-width: 728px) {
        .tp-widget-wrapper .wrapper-right {
            width: calc(100% - 200px)
        }
        .tp-widget-wrapper .wrapper-right .tp-widget-review__source__information {
            width: 250px
        }
        .tp-widget-wrapper .wrapper-right .tp-widget-review__source__arrow {
            left: 20%
        }
    }
    @media screen and (min-width: 930px) {
        .tp-widget-wrapper .wrapper-right {
            width: calc(100% - 200px)
        }
    }
    @media screen and (min-width: 1175px) {
        .tp-widget-wrapper .wrapper-right {
            width: calc(100% - 200px)
        }
    }

    .secondary-text {
        font-size: 0.7em;
    }
}

</style>
